"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguages = void 0;
const list_source_hook_1 = require("../../utils/list-source-hook");
function useLanguages() {
    return list_source_hook_1.useStaticListSource([
        { id: 'CZECH', name: 'Česky' },
        { id: 'ENGLISH', name: 'English' },
        { id: 'GERMAN', name: 'Deutch' },
        { id: 'SLOVAK', name: 'Slovensky' },
    ]);
}
exports.useLanguages = useLanguages;
//# sourceMappingURL=translations-api.js.map